export default __webpack_public_path__ + "resources/icons/d420-0519.webp";